<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader">
        </loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">On Hand</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">On Hand</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="inventory.id === null">New</span>
                  <span v-else>
                    {{ inventory.hand_no }}
                  </span>
                </li>
              </ol>
              <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
              <div class="dropdown-menu" aria-labelledby="printsales">
                <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setCOGSAll('reply')">Set COGS</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournal('reply')">Set Journal</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="approve">Approve</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="printBarcode">Print Barcode</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="addRecut">Re-cut</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="removeOnHand" v-if="authUser.permissions.inventory_on_hand_delete">Delete</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="unlock" v-if="authUser.permissions.inventory_on_hand_delete">Unlock</a>
              </div>
              <button type="button" @click="updateOnHand('reply')" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id && getRemaining == 0"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createOnHand" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id == null && getRemaining == 0"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-list">
            <div class="card-header">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <span v-if="inventory.id === null">New</span>
                  <span v-else>{{ inventory.hand_no }}</span>
                  <span class="badge badge-primary ml-1">{{ inventory.status }}</span>
                </h5>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Date</dt>
                    <dd class="col-md-8">
                        <datetime v-model="inventory.hand_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" :disabled="inventory.lock"></datetime>
                    </dd>

                    <dt class="col-md-4">Type</dt>
                    <dd class="col-md-8">
                      <select v-model="inventory.type" class="form-control form-control-lite" :disabled="inventory.lock">
                        <option value="in">In</option>
                        <option value="out">Out</option>
                        <option value="begin">Begin</option>
                      </select>
                    </dd>
                    <dt class="col-md-4">Name</dt>
                    <dd class="col-md-8">
                      <input type="text" v-model="inventory.name" class="form-control form-control-lite" :disabled="inventory.lock"/>
                    </dd>
                    <dt class="col-md-4">Company</dt>
                    <dd class="col-md-8">
                      <select v-model="inventory.company_no" class="form-control form-control-lite" :disabled="inventory.id !== null">
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                    </dd>

                    <dt class="col-md-4">Warehouse</dt>
                    <dd class="col-md-8">
                      <select v-model="inventory.warehouse_no" class="form-control form-control-lite" :disabled="inventory.lock">
                        <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">{{ w.name }}</option>
                      </select>
                    </dd>
                    <dt class="col-md-4">Notes</dt>
                    <dd class="col-md-8">
                      <textarea v-model="inventory.notes" class="form-control form-control-lite" :disabled="inventory.lock"/>
                    </dd>
                  </dl>
                </div>
                <div class="col-md-6" v-show="inventory.type !== 'out'">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Product No.</dt>
                    <dd class="col-md-8">
                      <v-select :options="getProductSelect" :reduce="product => product.meta.code" label="product" v-model="inventory.product_no" @input="setCProduct" :disabled="inventory.lock"/>
                    </dd>

                    <dt class="col-md-4">Quantity</dt>
                    <dd class="col-md-4">
                      <input type="text" class="form-control form-control-lite" v-model="inventory.qty" :disabled="inventory.lock"/>
                    </dd>
                    <dd class="col-md-4">
                      <select v-model="inventory.uom_id" class="form-control form-control-lite" :disabled="inventory.lock">
                        <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                      </select>
                    </dd>
                    <dt class="col-md-4">Total HPP</dt>
                    <dd class="col-md-8">
                      <input type="text" class="form-control form-control-lite" v-model="inventory.total_cost" v-money="money" disabled/>
                    </dd>
                    <dt class="col-md-4">Cost Per Item</dt>
                    <dd class="col-md-4">
                      <input type="text" class="form-control form-control-lite" :value="getCost" v-money="money" disabled/>
                    </dd>
                    <dd class="col-md-4">
                      <select v-model="inventory.uom_id" class="form-control form-control-lite" :disabled="inventory.lock">
                        <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                      </select>
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item"><a href="#detail" data-toggle="tab" aria-expanded="false" class="nav-link active">Product</a></li>
                    <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="detail">
                      <div class="table-responsive">
                        <button data-toggle="modal" data-target="#modalGetOnHandForm" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" @click="addProductToModal">
                          Add Product
                        </button>
                        <button class="btn btn-sm btn-hard-primary" @click="addName">Add Name</button>
                        <table class="table table-item table-sm table-hover">
                          <thead>
                            <th v-show="inventory.type === 'out'"></th>
                            <th style="width: 5%">Status</th>
                            <th style="width: 10%">Date</th>
                            <th style="width: 10%">Serial Number</th>
                            <th style="width: 25%">Product</th>
                            <th style="width: 5%">Qty</th>
                            <th style="width: 10%">Uom</th>
                            <th style="width: 5%">Qty Convert</th>
                            <th style="width: 5%">Uom</th>
                            <th style="width: 10%">Total</th>
                            <th style="width: 10%">Uom</th>
                            <th style="width: 10%">Used</th>
                            <th>#</th>
                            <!-- <th>Lock</th> -->
                          </thead>
                          <tbody>
                            <tr v-for="(d, index) in inventory.details" :key="d.id">
                              <td v-show="inventory.type === 'out'">
                                <button data-toggle="modal" data-target="#modalGetOnHand" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" @click="setIdDetail(index)" :disabled="inventory.lock || d.lock">
                                  <i class="fa fa-search" aria-hidden="true"></i>
                                </button>
                              </td>
                              <td>
                                <span class="badge badge-danger" v-if="d.c_type === 'out'">{{ d.c_type }}</span>
                                <span class="badge badge-info" v-else-if="d.c_type === 'convert-in'">{{ d.c_type }}</span>
                                <span class="badge badge-danger" v-else-if="d.c_type === 'convert-out'">{{ d.c_type }}</span>
                                <span class="badge badge-success" v-else>{{ d.c_type }}</span>
                              </td>
                              <td>
                                <datetime v-model="d.hand_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" :disabled="inventory.lock || inventory.type === 'out' || d.lock"></datetime>
                              </td>
                              <td><b>{{ d.serial_number }}</b></td>
                              <td><v-select :options="getProductSelect" :reduce="product => product.meta.code" label="product" v-model="d.product_no" :disabled="inventory.lock || inventory.type === 'out' || d.lock" @input="setProduct(index)"/></td>
                              <td><input type="text" v-model="d.qty_stock" class="form-control form-control-lite" @keyup="calcRow(index)" :disabled="inventory.lock || inventory.type === 'out' || d.lock"/></td>
                              <td>
                                <select v-model="d.uom_stock" class="form-control form-control-lite" disabled="disabled">
                                  <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                </select>
                              </td>
                              <td><input type="text" v-model="d.qty" class="form-control form-control-lite" @keyup="calcRow(index)" :disabled="inventory.lock || d.lock"></td>
                              <td>
                                <select v-model="d.uom_id" class="form-control form-control-lite" disabled="disabled">
                                  <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                </select>
                              </td>
                              <td><input type="text" v-model="d.qty_total" class="form-control form-control-lite" :disabled="inventory.lock || inventory.type === 'out' || d.lock"></td>
                              <td>
                                <select v-model="d.uom_total" class="form-control form-control-lite" disabled="disabled">
                                  <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                </select>
                              </td>
                              <td>
                                <input type="text" v-model="d.used_count" class="form-control" :disabled="inventory.lock">
                              </td>
                              <td>
                                <button class="btn btn-hard-primary btn-sm pull-left dropdown-toggle" type="button" id="actionRow" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">#</button>
                                <div class="dropdown-menu" aria-labelledby="actionRow">
                                  <a class="dropdown-item" href="#!" @click="removeRow(index)">Delete</a>
                                  <a class="dropdown-item" href="#!" @click="outInventory(d.id)">Out</a>
                                  <a class="dropdown-item" href="#!" @click="convert(index)" data-toggle="modal" data-target="#modalOnHandConvert" data-backdrop="static" data-keyboard="false">Convert</a>
                                </div>
                              </td>
                              <!-- <td>
                                <span v-if="d.lock === true" class="badge badge-danger">Lock</span>
                                <span v-else class="badge badge-success">Open</span>
                              </td> -->
                            </tr>
                            <tr>
                              <td v-if="inventory.type === 'in'" colspan="10">
                                <!-- <span @click="addNewDetail" class="link-secondary" v-show="inventory.lock === false && getRemaining > 0 || inventory.type === 'out'">+ Add Product</span> -->
                              </td>
                              <td v-if="inventory.type === 'begin'" colspan="10">
                                <!-- <span @click="addNewDetail" class="link-secondary" v-show="inventory.lock === false">+ Add Product</span> -->
                              </td>
                              <td v-else colspan="11">
                                <!-- <span @click="addNewDetail" class="link-secondary" v-show="inventory.lock === false && getRemaining > 0 || inventory.type === 'out'">+ Add Product</span> -->
                              </td>
                            </tr>
                            <tr>
                              <td v-if="inventory.type !== 'out'" colspan="7"></td>
                              <td v-else colspan="8"></td>
                              <td class="text-right"><b>Total</b></td>
                              <td class="text-right">{{ getTotal }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr v-show="inventory.type !== 'out'">
                              <td colspan="7"></td>
                              <td class="text-right"><b>Remaining</b></td>
                              <td class="text-right">{{ getRemaining }}</td>
                              <td class="text-center">
                                <button class="btn btn-sm btn-danger" @click="setRemaining" v-show="getRemaining > 0">Dump</button>
                              </td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="tab-pane" id="journal">
                      <div class="table-responsive">
                        <table class="table table-sm table-item table-hover table-striped">
                          <thead>
                            <th>Journal Code</th>
                            <th>Date</th>
                            <th>Account Code</th>
                            <th>Remark</th>
                            <th class="text-right">Debit</th>
                            <th class="text-right">Credit</th>
                          </thead>
                          <tbody>
                            <tr v-for="j in inventory.journals" :key="j.id">
                              <td>
                                <span v-if="j.level === 1">
                                  <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                  <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                  <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                </span>
                                <span v-else></span>
                              </td>
                              <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                              <td>{{ j.remark }}</td>
                              <td class="text-right">
                                <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                <span v-else></span>
                              </td>
                              <td class="text-right">
                                <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                <span v-else></span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in inventory.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <InventoryOnHandModal @selectOH="selectOH" :inventory="inventory"/>
      <InventoryOnHandFormModal :addProduct="addProduct" @processAddProduct="processAddProduct"/>
      <InventoryOnHandConvertModal :onhand="dataDetail" @convertProcess="convertProcess"/>
      <!-- <div class="row">
        <div class="col-md-4">
          <pre>{{ inventory.details }}</pre>
        </div>
        <div class="col-md-4">
          <pre>{{ productListCogs }}</pre>
        </div>
      </div> -->
      <!-- <ManufactureProductModal @selectProduct="selectProduct" :manufacture="manufacture" :date="manufacture.manufacture_date"/> -->
      <!-- <div class="row">
        <div class="col-md-4">
          <pre>{{ manufacture }}</pre>
        </div>
        <div class="col-md-4">
          <pre>{{ dataCollect }}</pre>
        </div>
        <div class="col-md-4">
          <pre>{{ dataCollectMaterial }}</pre>
          <pre>{{ dataCollectExpense }}</pre>
        </div>
      </div> -->
      <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid"/>
    </div>
</template>

<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, inventoryUrl, inventory2Url, productUrl, lockUrl } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
// import ManufactureProductModal from '@/components/manufacture/ManufactureProductModal.vue'
import InventoryOnHandModal from '@/components/inventory/InventoryOnHandModal.vue'
import InventoryOnHandFormModal from '@/components/inventory/InventoryOnHandFormModal.vue'
import InventoryOnHandConvertModal from '@/components/inventory/InventoryOnHandConvertModal.vue'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'

export default {
  name: 'InventoryOnHandForm',
  props: ['inventory'],
  components: {
    Loading,
    InventoryOnHandModal,
    InventoryOnHandFormModal,
    InventoryOnHandConvertModal,
    SalesRequestModal
  },
  data () {
    return {
      dataDetail: {
        id: null,
        hand_no: null,
        hand_date: null,
        company_no: null,
        branch_no: null,
        warehouse_no: null,
        serial_number: null,
        product_no: null,
        product_description: null,
        qty_stock: null,
        uom_stock: null,
        qty: null,
        uom_id: null,
        qty_total: null,
        uom_total: null,
        cost: null,
        cost_id: null,
        notes: null,
        type: null,
        c_type: null,
        lock: null,
        qty_convert: '0'
      },
      ref: null,
      refNo: null,
      idDetail: null,
      detail: null,
      materialIndex: null,
      addProduct: {
        product_no: null,
        qty_stock: '0',
        qty: '0',
        uom_id: null
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      brachList: state => state.branches.branchList,
      uomList: state => state.uom.uomList,
      warehouseList: state => state.warehouses.warehouseList,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser,
      productListSelect: state => state.products.productListSelect,
      productListCogs: state => state.products.productListCogs
    }),
    getProductSelect () {
      var array = this.productListSelect
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: '[' + array[i].product_no + '] ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getTotal () {
      var array = this.inventory.details.filter(d => d.lock !== true)
      var total = 0
      for (let i = 0; i < array.length; i++) {
        total += parseFloat(array[i].qty_total)
      }
      return total.toFixed(2)
    },
    getCost () {
      var totalCost = 0
      if (this.inventory.total_cost) {
        totalCost = this.inventory.total_cost.toString().replace(/\./g, '').replace(/,/g, '.')
      }
      var qty = parseFloat(this.inventory.qty)
      var total = totalCost / qty
      return total.toFixed(2)
    },
    getRemaining () {
      var array = this.inventory.details.filter(d => d.lock !== true)
      var subtotal = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].c_type !== 'convert-in') {
          subtotal += parseFloat(array[i].qty_total)
        }
      }
      var total = parseFloat(this.inventory.qty) - parseFloat(subtotal)

      if (this.inventory.type !== 'out') {
        return total.toFixed(2)
      } else {
        return 0
      }
    }
  },
  methods: {
    async unlock () {
      await Axios.post(inventoryUrl + '/on-hand/unlock', { id: this.inventory.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.inventory.lock = response.data.data.lock
          this.inventory.status = response.data.data.status
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestVoid () {
      console.log('requestVoid')
    },
    async removeOnHand () {
      await this.$Progress.start()
      this.loader.isLoading = true
      await Axios.delete(inventoryUrl + '/on-hand/' + this.inventory.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.setCOGSAll('reply')
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backSaveClicked')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.inventory.hand_no,
        lock_note: value,
        type: 'on-hand'
      }
      await Axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Lock',
            'On Hand has been requested',
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    convertProcess (value) {
      const detail = this.inventory.details.find(d => d.serial_number === value.serial_number)
      detail.date_out = new Date().toISOString()
      detail.c_type = 'convert-out'
      detail.out_by = this.authUser.id
      var obj = {
        hand_no: null,
        hand_date: new Date().toISOString(),
        company_no: this.inventory.company_no,
        branch_no: this.inventory.branch_no,
        warehouse_no: this.inventory.warehouse_no,
        serial_number: value.serial_number,
        product_no: value.product_no,
        product_description: value.product_description,
        qty_stock: value.qty_convert,
        uom_stock: value.uom_stock,
        qty: 1,
        uom_id: 'lembar',
        qty_total: value.qty_stock,
        uom_total: this.inventory.uom_id,
        cost: null,
        cost_id: null,
        notes: null,
        type: this.inventory.type,
        c_type: 'convert-in',
        lock: false
      }
      this.inventory.details.push(obj)
    },
    convert (index) {
      const detail = this.inventory.details[index]
      this.dataDetail = {
        id: detail.id,
        hand_no: detail.hand_no,
        hand_date: detail.hand_date,
        company_no: detail.company_no,
        branch_no: detail.branch_no,
        warehouse_no: detail.warehouse_no,
        serial_number: detail.serial_number,
        product_no: detail.product_no,
        product_description: detail.product_description,
        qty_stock: detail.qty_stock,
        uom_stock: detail.uom_stock,
        qty: detail.qty,
        uom_id: detail.uom_id,
        qty_total: detail.qty_total,
        uom_total: detail.uom_total,
        cost: detail.cost,
        cost_id: detail.cost_id,
        notes: detail.notes,
        type: detail.type,
        c_type: detail.c_type,
        lock: detail.lock,
        qty_convert: '0'
      }
    },
    async outInventory (id) {
      var detail = this.inventory.details.find(d => d.id === id)
      await this.$swal.fire({
        title: 'Are you sure Out this <br>' + detail.serial_number,
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          var obj = {
            id: id
          }
          Axios.post(inventoryUrl + '/on-hand/inventory-out', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              console.log(response.data.data)
              this.$emit('backClickID', this.inventory.id)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    addName () {
      var product = this.productListSelect.find(d => d.product_no === this.inventory.product_no)
      var detail = this.inventory.details[0]
      this.inventory.name = product.product_name + '  (' + detail.qty_stock + ' ' + detail.uom_stock + ')'
    },
    async addProductToModal () {
      this.addProduct = {
        product_no: this.inventory.product_no,
        qty_stock: '0',
        qty: '0',
        uom_id: this.inventory.uom_id
      }
      console.log(this.addProduct)
    },
    async processAddProduct (value) {
      for (let i = 0; i < parseFloat(value.qty); i++) {
        var obj = {
          hand_no: null,
          hand_date: this.inventory.hand_date,
          company_no: this.inventory.company_no,
          branch_no: this.inventory.branch_no,
          warehouse_no: this.inventory.warehouse_no,
          serial_number: 'New',
          product_no: this.inventory.product_no,
          product_description: null,
          qty_stock: value.qty_stock,
          uom_stock: this.inventory.uom_id,
          qty: 1,
          uom_id: 'lembar',
          qty_total: value.qty_stock,
          uom_total: this.inventory.uom_id,
          cost: null,
          cost_id: null,
          notes: null,
          type: this.inventory.type,
          c_type: 'in',
          lock: false
        }
        this.inventory.details.push(obj)
      }
      await this.addName()
    },
    async approve () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        id: this.inventory.id
      }
      await this.updateOnHand('no reply')
      await this.setJournal('no reply')
      await Axios.post(inventoryUrl + '/on-hand/approve', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async setJournal (reply) {
      if (reply === 'reply') {
        this.$Progress.start()
        this.loader.isLoading = true
      }
      var obj = {
        id: this.inventory.id
      }
      var resp = {
        error: false,
        message: null
      }
      await Axios.post(inventoryUrl + '/on-hand/journal', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      if (reply === 'reply') {
        if (resp.error === false) {
          this.$Progress.finish()
          this.loader.isLoading = false
          await this.$swal('On Hand Journal', resp.message, 'success')
        } else {
          this.$Progress.finish()
          this.loader.isLoading = false
          await this.$swal('On Hand Journal', resp.message, 'error')
        }
      }
    },
    async setCOGSAll (reply) {
      if (reply === 'reply') {
        this.$Progress.start()
        this.loader.isLoading = true
      }
      var data = {
        product_no: this.inventory.product_no,
        date: this.inventory.hand_date,
        type: 'all',
        company_no: this.inventory.company_no
      }
      var resp = {
        error: false,
        message: null
      }
      await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      if (reply === 'reply') {
        if (resp.error === false) {
          await this.$Progress.finish()
          this.loader.isLoading = false
          await this.$swal('On Hand', resp.message, 'success')
        } else {
          await this.$Progress.finish()
          this.loader.isLoading = false
          await this.$swal('On Hand', resp.message, 'error')
        }
      }
    },
    setIdDetail: function (id) {
      this.idDetail = id
      var pyd = {
        company: this.authUser.company_no,
        type: 'in'
      }
      this.$store.dispatch('getInventoryOnHandProductList', pyd)
    },
    selectOH (value) {
      var detail = this.inventory.details[this.idDetail]
      var date = new Date(value.hand_date)
      detail.hand_date = date.toISOString()
      detail.product_no = value.product_no
      detail.product_description = value.product_description
      detail.qty_stock = value.qty_stock
      detail.uom_stock = value.uom_stock
      detail.qty = 0
      detail.uom_id = 'lembar'
      detail.qty_total = 0
      detail.uom_total = value.uom_stock
      detail.cost = value.cost
      detail.cost_id = value.cost_id
      detail.notes = value.notes
    },
    async updateOnHand (reply) {
      if (reply === 'reply') {
        this.$Progress.start()
        this.loader.isLoading = true
      }
      this.inventory.lock = true
      var onHand = {}
      await Axios.put(inventoryUrl + '/on-hand/' + this.inventory.id, this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          onHand = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var product = this.productListSelect.find(d => d.product_no === array[i].product_no)
        var data = {}
        if (typeof array[i].id === 'undefined') {
          data = {
            hand_no: onHand.hand_no,
            hand_date: array[i].hand_date,
            company_no: onHand.company_no,
            branch_no: onHand.branch_no,
            warehouse_no: onHand.warehouse_no,
            serial_number: array[i].serial_number,
            product_no: array[i].product_no,
            product_description: product ? product.product_name : null,
            qty_stock: array[i].qty_stock,
            uom_stock: array[i].uom_stock,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            qty_total: array[i].qty_total,
            uom_total: array[i].uom_total,
            cost: array[i].cost,
            cost_id: array[i].cost_id,
            notes: array[i].notes,
            type: onHand.type,
            c_type: array[i].c_type,
            lock: array[i].lock !== null ? array[i].lock : false,
            date_out: array[i].date_out,
            out_by: array[i].out_by,
            used_count: array[i].used_count
          }
        } else {
          data = {
            id: array[i].id,
            hand_no: onHand.hand_no,
            hand_date: array[i].hand_date,
            company_no: onHand.company_no,
            branch_no: onHand.branch_no,
            warehouse_no: onHand.warehouse_no,
            serial_number: array[i].serial_number,
            product_no: array[i].product_no,
            product_description: product ? product.product_name : null,
            qty_stock: array[i].qty_stock,
            uom_stock: array[i].uom_stock,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            qty_total: array[i].qty_total,
            uom_total: array[i].uom_total,
            cost: array[i].cost,
            cost_id: array[i].cost_id,
            notes: array[i].notes,
            type: onHand.type,
            c_type: array[i].c_type,
            lock: array[i].lock !== null ? array[i].lock : false,
            date_out: array[i].date_out,
            out_by: array[i].out_by,
            used_count: array[i].used_count
          }
        }
        await Axios.post(inventoryUrl + '/on-hand/detail', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error.response)
          })
      }
      if (this.inventory.type === 'in') {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Inventory', 'Process HPP & Journal?', 'success')
        await this.$Progress.start()
        this.loader.isLoading = true
        await this.setCOGSAll('no reply')
        await this.setJournal('no reply')
        if (reply === 'reply') {
          await this.$swal('Success', 'Update On Hand', 'success')
          await this.$emit('backSaveClicked')
          await this.$Progress.finish()
          this.loader.isLoading = false
        }
      } else {
        await this.$swal('Success', 'Update On Hand', 'success')
        await this.$emit('backSaveClicked')
        await this.$Progress.finish()
        this.loader.isLoading = false
      }
    },
    async createOnHand () {
      var onHand = {}
      this.inventory.lock = true
      var handID = null
      await Axios.post(inventoryUrl + '/on-hand', this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          onHand = response.data.data
          handID = response.data.data.id
          // this.printBarcode()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var product = this.productListSelect.find(d => d.product_no === array[i].product_no)
        var data = {
          hand_no: onHand.hand_no,
          hand_date: array[i].hand_date,
          company_no: onHand.company_no,
          branch_no: onHand.branch_no,
          warehouse_no: onHand.warehouse_no,
          serial_number: array[i].serial_number,
          product_no: array[i].product_no,
          product_description: product ? product.product_name : null,
          qty_stock: array[i].qty_stock,
          uom_stock: array[i].uom_stock,
          qty: array[i].qty,
          uom_id: array[i].uom_id,
          qty_total: array[i].qty_total,
          uom_total: array[i].uom_total,
          cost: array[i].cost,
          cost_id: array[i].cost_id,
          notes: array[i].notes,
          type: onHand.type,
          c_type: array[i].c_type,
          lock: array[i].lock !== null ? array[i].lock : false,
          used_count: array[i].used_count
        }
        await Axios.post(inventoryUrl + '/on-hand/detail', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      if (this.inventory.type === 'in') {
        this.$emit('backClickID', handID)
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Inventory', 'Process HPP & Journal?', 'success')
        await this.$Progress.start()
        this.loader.isLoading = true
        await this.setCOGSAll('no reply')
        await this.setJournal('no reply')
        await this.$swal('Success', 'Create On Hand', 'success')
        await this.$emit('backSaveClicked')
        await this.$Progress.finish()
        this.loader.isLoading = false
      } else {
        await this.$swal('Success', 'Create On Hand', 'success')
        await this.$emit('backSaveClicked')
        await this.$Progress.finish()
        this.loader.isLoading = false
      }
    },
    async printBarcode () {
      var data = { data: this.inventory.details }
      console.log(data)
      await Axios.post(inventory2Url + '/on-hand/barcode', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.message)
        })
    },
    removeRow (index) {
      var detail = this.inventory.details[index]
      if (typeof detail.id === 'undefined') {
        this.inventory.details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(inventoryUrl + '/on-hand/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.inventory.details.splice(index, 1)
                this.$swal('Success', response.data.message, 'success')
              })
              .catch(error => {
                console.log(error.data.message)
                this.$swal('Error', error.data.message, 'error')
              })
          }
        })
      }
    },
    calcRow (index) {
      var detail = this.inventory.details[index]
      var total = parseFloat(detail.qty_stock) * parseFloat(detail.qty)
      if (isNaN(total)) {
        detail.qty_total = 0
      } else {
        detail.qty_total = total
      }
    },
    setCProduct: function () {
      var product = this.productListSelect.find(p => p.product_no === this.inventory.product_no)
      console.log(product)
      this.inventory.uom_id = product.uom_id
      this.inventory.cost = product.price === null ? '0' : product.price
    },
    setProduct (index) {
      var detail = this.inventory.details[index]
      var product = this.productListSelect.find(d => d.product_no === detail.product_no)
      console.log(product)
      detail.uom_stock = product.uom_id
      detail.uom_id = 'lembar'
      detail.uom_total = product.uom_id
    },
    addNewDetail () {
      var obj = {
        hand_no: null,
        hand_date: this.inventory.hand_date,
        company_no: this.inventory.company_no,
        branch_no: this.inventory.branch_no,
        warehouse_no: this.inventory.warehouse_no,
        serial_number: null,
        product_no: this.inventory.product_no,
        product_description: null,
        qty_stock: 0,
        uom_stock: this.inventory.uom_id,
        qty: 0,
        uom_id: 'lembar',
        qty_total: 0,
        uom_total: this.inventory.uom_id,
        cost: null,
        cost_id: null,
        notes: null,
        type: this.inventory.type,
        c_type: this.inventory.type,
        lock: false,
        date_out: null,
        out_by: null
      }
      this.inventory.details.push(obj)
    },
    addRecut () {
      this.inventory.lock = false
      var date = new Date()
      var data = []
      var array = this.inventory.details.filter(d => d.c_type === 'in')
      for (let i = 0; i < array.length; i++) {
        array[i].lock = true
        var obj = {
          hand_no: array[i].hand_no,
          hand_date: date.toISOString(),
          company_no: array[i].company_no,
          branch_no: array[i].branch_no,
          warehouse_no: array[i].warehouse_no,
          serial_number: array[i].serial_number,
          product_no: array[i].product_no,
          product_description: array[i].product_description,
          qty_stock: array[i].qty_stock,
          uom_stock: array[i].uom_stock,
          qty: array[i].qty,
          uom_id: array[i].uom_id,
          qty_total: array[i].qty_total,
          uom_total: array[i].uom_total,
          cost: array[i].cost,
          cost_id: array[i].cost_id,
          notes: array[i].notes,
          type: array[i].type,
          c_type: 'out',
          lock: true
        }
        data.push(obj)
      }
      for (let j = 0; j < data.length; j++) {
        this.inventory.details.push(data[j])
      }
    },
    setRemaining () {
      var date = new Date()
      var obj = {
        hand_no: null,
        hand_date: date.toISOString(),
        company_no: this.inventory.company_no,
        branch_no: this.inventory.branch_no,
        warehouse_no: this.inventory.warehouse_no,
        serial_number: null,
        product_no: this.inventory.product_no,
        product_description: null,
        qty_stock: this.getRemaining,
        uom_stock: this.inventory.uom_id,
        qty: 1,
        uom_id: this.inventory.uom_id,
        qty_total: this.getRemaining,
        uom_total: this.inventory.uom_id,
        cost: null,
        cost_id: null,
        notes: null,
        type: this.inventory.type,
        c_type: 'out',
        lock: false
      }
      this.inventory.details.push(obj)
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  },
  mounted () {
    this._keyListener = function (e) {
      if (e.key === 's' && (e.ctrlKey || e.metaKey)) {
        e.preventDefault()
      }
    }

    document.addEventListener('keydown', this._keyListener.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._keyListener)
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
